module.exports = __webpack_public_path__ + "static/media/awards.580a791d.svg";